import { createFileRoute } from "@tanstack/react-router";

import { ZoneFormPage } from "@/components/zones/form";
import { RequirePermission } from "@/hooks/shared/CheckAuth";

export const Route = createFileRoute("/_main/dashboard/zones/$id/edit")({
  component: () => (
    <RequirePermission action="zones.write">
      <ZoneFormPage />
    </RequirePermission>
  ),
});
